/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：131__part-1
 */

"use strict"

var i
var o
var r
import * as /* [auto-meaningful-name] */Module_11 from /* 11 */"./11"
import * as /* [auto-meaningful-name] */Src_editor_widget_builtIn_types from /* 5 */"../../../../src/editor/widget/built-in/types"
import * as /* [auto-meaningful-name] */Module_163 from /* 163 */"./163"
var /* [auto-meaningful-name] */_5DC5FBFF = "#5DC5FBFF"
var /* [auto-meaningful-name] */IconWidgetSwitch = "icon-widget-switch"
var d = false
var p = false
var /* [auto-meaningful-name] */Https__creation$codemao$cn_884_l4zc62tv$png = "https://creation.codemao.cn/884/l4zc62tv.png"
var /* [auto-meaningful-name] */Https__creation$codemao$cn_884_l4zc62wn$png = "https://creation.codemao.cn/884/l4zc62wn.png"
var m = 54
var g = 30
var _ = m / g
var v = 26
var b = 14
i = {}
Module_11.a(i, Module_163.c.DEFAULT, (r = {}, Module_11.a(r, Src_editor_widget_builtIn_types.s.SMALL, {
  width: 26,
  height: 14
}), Module_11.a(r, Src_editor_widget_builtIn_types.s.MEDIUM, {
  width: 36,
  height: 20
}), Module_11.a(r, Src_editor_widget_builtIn_types.s.LARGE, {
  width: 46,
  height: 26
}), r))
Module_11.a(i, Module_163.c.PRIMARY, (o = {}, Module_11.a(o, Src_editor_widget_builtIn_types.s.SMALL, {
  width: 32,
  height: 18
}), Module_11.a(o, Src_editor_widget_builtIn_types.s.MEDIUM, {
  width: 46,
  height: 26
}), Module_11.a(o, Src_editor_widget_builtIn_types.s.LARGE, {
  width: 60,
  height: 34
}), o))
var y = i
export { _5DC5FBFF as l }
export { IconWidgetSwitch as u }
export { d }
export { p }
export { Https__creation$codemao$cn_884_l4zc62tv$png as f }
export { Https__creation$codemao$cn_884_l4zc62wn$png as h }
export { m }
export { g }
export { _ }
export { v }
export { b }
export { y }
